export enum FLASHCARDS_DECKS_STATUSES {
  READY = 'READY',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  EMPTY = 'EMPTY',
}

export const MAX_FLASHCARD_TEXT_LENGTH = 262;
export const FLASHCARDS_DECKS_TITLE_MAX_LENGTH = 50;

export * from './error-codes';
export * from './model';
